import React from 'react';
import { Redirect } from 'react-router-dom';

import { lazyLoad } from '@/lib/utils';

import { ORG_RESOURCE_ID_PATH, ROOT_PATH, START_PATH } from './constants';

const HomePage = lazyLoad(() => import('containers/HomePage'));
const PrivateContainer = lazyLoad(
  () => import('@/components/layouts/PrivateContainer'),
);

/**
 * ROUTES
 *
 * This file contains the routing configuration for the application.
 * It defines all route paths and their corresponding components.
 * The routes are defined in an array of objects, each containing the path,
 * component, and any additional properties needed for the route.
 *
 * @type {Array}
 */
const ROUTES = [
  {
    path: ROOT_PATH,
    exact: true,
    render: (props) => <Redirect to={START_PATH} state={props} />,
    inheritComponentProps: true,
  },
  {
    path: START_PATH,
    exact: true,
    render: (props) => <HomePage {...props} />,
    isPrivate: true,
    inheritIsAuthenticatedState: true,
    inheritComponentProps: true,
  },
  {
    path: ORG_RESOURCE_ID_PATH,
    render: (props) => <PrivateContainer {...props} />,
    isPrivate: true,
    inheritIsAuthenticatedState: true,
    inheritComponentProps: true,
  },
];

export default ROUTES;
